import React, {Component} from 'react';
import {Autocomplete, TextField} from '@mui/material';

import Api from '../api';
import {LIST_OPERATORS_URL} from '../lib/constant';

// Free-text combobox for a downstream DLT Telemarketer ID (TM-D).
// Suggestions come from the operators list (each operator record carries the
// dlt_tm_id its chain is registered under) — distinct non-empty IDs labelled
// "<dlt_tm_id> (<operator name>)". The operators endpoint is admin-only, so
// on any failure the field silently degrades to a plain free-text input.
export default class DltTmdField extends Component {
  state = {suggestions: []};

  componentDidMount() {
    Api.get(LIST_OPERATORS_URL)
      .then(({data}) => {
        const operators = data?.data?.operators || data?.operators || [];
        const seen = new Map();
        operators.forEach((op) => {
          const tmId = op.dltTmId || op.dlt_tm_id || '';
          if (tmId && !seen.has(tmId)) {
            seen.set(tmId, op.name || op.code || '');
          }
        });
        const suggestions = Array.from(seen, ([value, name]) => ({
          value,
          label: name ? `${value} (${name})` : value,
        }));
        this.setState({suggestions});
      })
      .catch(() => {
        // Non-admin users can't list operators — keep the plain text input.
      });
  }

  render() {
    const {label, value, onChange, helperText, textFieldProps} = this.props;
    const {suggestions} = this.state;
    return (
      <Autocomplete
        freeSolo
        fullWidth={!!(textFieldProps && textFieldProps.fullWidth)}
        options={suggestions}
        getOptionLabel={(opt) => (typeof opt === 'string' ? opt : opt.label)}
        inputValue={value || ''}
        onInputChange={(e, newValue, reason) => {
          // 'reset' fires when a suggestion is picked (with the display label)
          // — the plain ID is stored via onChange below instead.
          if (reason !== 'reset') onChange(newValue);
        }}
        onChange={(e, newValue) => {
          if (newValue) {
            onChange(typeof newValue === 'string' ? newValue : newValue.value);
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            helperText={helperText}
            {...textFieldProps}
          />
        )}
      />
    );
  }
}
